
    var riot = require('riot')
    //src: shared/tags/switch.html
riot.tag2('switch',
  '<input id="{opts.name}_checkbox" class="Switch_input" type="checkbox" name="{opts.name}" checked="{opts.checked}" disabled="{opts.disabled}" onchange="{opts.toggle}"> <label for="{opts.name}_checkbox" class="Switch_track"> <span class="Switch_thumb"></span> </label> <label if="{opts.labelOn}" for="{opts.name}_checkbox" class="Switch_label Switch_label--on"> {opts.labelOn} </label> <label if="{opts.labelOff}" for="{opts.name}_checkbox" class="Switch_label Switch_label--off"> {opts.labelOff} </label>',
  '',
  'class="Switch"', function(opts) {
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('switch')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./shared/tags/switch.html
// module id = 802
// module chunks = 0